import { render, staticRenderFns } from "./imageViewComMu.vue?vue&type=template&id=4b226fa9&scoped=true&"
import script from "./imageViewComMu.vue?vue&type=script&lang=ts&"
export * from "./imageViewComMu.vue?vue&type=script&lang=ts&"
import style0 from "./imageViewComMu.vue?vue&type=style&index=0&id=4b226fa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b226fa9",
  null
  
)

export default component.exports